import posthog from 'posthog-js';

import {
  type AssortmentNewTableEvents,
  type AssortmentTableEvents,
  type AssortmentTemplateImportExportEvent,
} from './assortment';
import {
  type BuyingAssortmentStepEvent,
  type BuyingBatchNavigationEvent,
  type BuyingBudgetStepEvent,
  type BuyingSavedViewsEvent,
  type BuyingScopeStepEvent,
  type BuyingShoppingListStepEvent,
} from './buying';
import { type BuyingOverviewEvent } from './buying';
import { type BuyingIdealBuyStepEvent } from './buying/buying-ideal-buy.types';
import { type CommonEvent } from './common';
import { type EventAppEvent, type EventScopeEvent } from './events';
import { type FiltersDrawerEvent } from './filters';
import {
  type InsightsOverviewEvent,
  type InsightsThoughtspotEvent,
} from './insights';
import {
  type ParameterActionEvent,
  type ParameterDownloadModalEvent,
} from './parameters';
import {
  type RebalBatchCreationEvent,
  type RebalBatchOverviewEvent,
  type RebalBatchReviewEvent,
  type RebalNewBatchReviewEvent,
  type RebalScopeEvent,
} from './rebalancing';
import {
  type ReorderBatchCreationEvent,
  type ReorderBatchOverviewEvent,
  type ReorderBatchReviewEvent,
} from './reorder';
import {
  type ReplenBatchCreationEvent,
  type ReplenBatchOverviewEvent,
  type ReplenBatchReviewEvent,
} from './replenishment';
import { type SidebarEvent } from './sidebar';

export type AnalyticsEvent =
  | ReplenBatchCreationEvent
  | ReplenBatchReviewEvent
  | ReplenBatchOverviewEvent
  | ReorderBatchCreationEvent
  | ReorderBatchOverviewEvent
  | ReorderBatchReviewEvent
  | RebalBatchOverviewEvent
  | RebalBatchCreationEvent
  | RebalBatchReviewEvent
  | RebalNewBatchReviewEvent
  | RebalScopeEvent
  | ParameterActionEvent
  | ParameterDownloadModalEvent
  | BuyingScopeStepEvent
  | BuyingOverviewEvent
  | AssortmentTemplateImportExportEvent
  | AssortmentTableEvents
  | AssortmentNewTableEvents
  | EventScopeEvent
  | EventAppEvent
  | BuyingIdealBuyStepEvent
  | BuyingBatchNavigationEvent
  | BuyingBudgetStepEvent
  | BuyingShoppingListStepEvent
  | BuyingAssortmentStepEvent
  | BuyingSavedViewsEvent
  | InsightsOverviewEvent
  | InsightsThoughtspotEvent
  | SidebarEvent
  | CommonEvent
  | FiltersDrawerEvent;

export const trackAnalyticsEvent = (event: AnalyticsEvent) => {
  const { category, action, properties } = event;

  return posthog.capture(`${category}:${action}`, {
    category,
    ...properties,
  });
};

export const trackAnalyticsEventLegacy = (
  action: string,
  properties?: Record<string, unknown>,
) => {
  const category = 'legacy';

  return posthog.capture(`${category}:${action}`, {
    ...(properties || {}),
  });
};
